<template>
	<Col class="buttons-dropdowns-list height-100">
		<template v-if="buttonDropdowns?.length > 0">
			<ButtonsDropdownCard
				class="height-100 mb-3"
				:key="buttonDropdown.id"
				:buttonDropdown="buttonDropdown"
				v-for="buttonDropdown in buttonDropdowns"
			/>
		</template>
		<template v-else-if="!isLoading">
			<h3 class="reg empty-container flex-centerize">Nothing to see here</h3>
			<h2 @click="$emit('show-wizard')" class="create-new reg flex-centerize">Create new +</h2>
		</template>
	</Col>
</template>
<script>
import ButtonsDropdownCard from '@/views/ButtonsDropdownView/ButtonsDropdownCard.vue';
export default {
	name: 'ButtonsDropdownList',
	components: { ButtonsDropdownCard },
	props: { isLoading: { type: Boolean }, buttonDropdowns: { type: Array } },
};
</script>
<style scoped lang="scss">
.buttons-dropdowns-list {
	display: flex;
	flex-direction: column;
	@media (max-width: 1100px) {
		padding: 10px 20px 10px 25px;
	}
}
.empty-container {
	margin-top: 150px;
}
.create-new {
	cursor: pointer;
	color: #6762f0;
	margin-top: 10px;
	text-decoration: underline;
}
</style>
